import { render } from "./Image-modal.vue?vue&type=template&id=f5da36c8"
import script from "./Image-modal.vue?vue&type=script&lang=js"
export * from "./Image-modal.vue?vue&type=script&lang=js"

import "./Image-modal.vue?vue&type=style&index=0&id=f5da36c8&lang=scss"

import exportComponent from "C:\\Users\\mm\\Documents\\__Kundenprojekte\\ÜIM-HAB\\Entwicklung\\Frontend\\uebersetzen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__